export default function AutoPracticeAboutDialogTemplate(data) {
    //language=HTML
    return `
        <div id="aboutDialog">
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("appVersionNumber")}
            </span>
                <span class="col-md-9">
                ${data.applicationVersion}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("dbBuildDate")}
            </span>
                <span class="col-md-9">
                ${data.dbBuildDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("latestRelease")}
            </span>
                <span class="col-md-9">
                ${data.latestRelease}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("customerSupportEndDate")}
            </span>
                <span class="col-md-9">
                ${data.customerSupportEndDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("licenceDetails")}
            </span>
                <span class="col-md-9">
                ${data.licenceDetails}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("contactInfo")}
            </span>
                <span class="col-md-9">
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("egypt")}
            </span>
                <div class="col-md-9">
                    <address>Auto Practice</address>
                    <address>
                        11ش عبدالحليم النجار - متفرع من عباس العقاد - مدينة نصر - القاهرة
                    </address>
                    <address>
                        11 Abdelhalim El-Nagar-Nasr city-Cairo
                    </address>
                    <address>
                        <a href="https://autopractise.com/">autopractise.com</a>
                    </address>
                    <address>
                        <a href="emailto:info@autopractise.com ">info@autopractise.com</a>
                    </address>
                    <address>
                        <a href="https://www.facebook.com/autoperp">Facebook</a>
                    </address>
                    <address>
                        <a href="https://www.instagram.com/autoperp/">Instagram</a>
                    </address>
                    <address>
                        <a href="https://x.com/AutoPERP">X</a>
                    </address>
                    <address>
                        <a href="https://www.linkedin.com/company/autoperp/">LinkedIn</a>
                    </address>
                    <address>
                        <a href="https://www.youtube.com/@AutoPERP">Youtube</a>
                    </address>
                    <address>
                        <a href="https://www.snapchat.com/add/AutoPERP">Snapchat</a>
                    </address>
                    <address>
                        <a href="https://www.tiktok.com/@autoperp">Tiktok</a>
                    </address>
                </div>
            </div>
            
            <div class="row topBordered w-100">
                <div class="col-md-12">
                    <div class="textAlignCenter">
                        <a href='${data.translateId("appUrl")}' target="_blank">${data.translateId("appUrl")}</a>
                    </div>
                </div>
            </div>
        </div>`;
}